import React, { useState } from "react";
import "./QuiSuisJe.css";
import nicolas from '../assets/TRH-illustration-rugby.jpg';

const QuiSuisJe = () => {
  return (
      <section id="qui-suis-je" className="section fade-in">
         <div className="sectionContent">
        <h2>Qui suis-je </h2>
        <img src={nicolas} alt="TRH Menuiserie logo" className="nicolas" />
        <br/> 
        <p>Je m'appelle <strong>Nicolas</strong> et j'ai lancé mon activité indépendante début 2024, après plus de <strong>10 ans d'expérience</strong> au sein de la même entreprise en tant que <strong>Miroitier</strong>.</p> 
        <p>Aujourd'hui, je me consacre entièrement à la <strong>pose de menuiserie</strong>, alliant savoir-faire et passion pour répondre <u>à votre besoin</u>.</p>
        <p>En dehors de mon métier, je suis également un fervent joueur de rugby, avec plus de <strong>20 ans d'expérience</strong> au <strong>RC Arles XV</strong>. </p>
        <p>La discipline et l'esprit d'équipe que j'ai acquis sur le terrain se reflètent dans ma manière de travailler, garantissant ainsi un service toujours <u>professionnel et efficace</u>.</p>
        </div></section>
  );
};

export default QuiSuisJe;
